import React from "react";
import { Popover } from "react_reusable_components";
import MyNotificationsPopUpContent from "../MyNotificationsPopUpContent";
import useResponsive from "core/hooks/useResponsive";
import variables from "../../themes/base/styles/variables";

const MyNotificationsPopupContainerStyle = {
  overlayStyle: {
    border: `1px solid ${variables.grey5}`,
    backgroundColor: variables.bodyBg,
    top: variables.accountsPopUpTop,
    boxShadow: variables.notificationBoxShadow,
  },
};

export default function ViewNotificationsPopupContainer({
  open,
  handleClose,
  icon,
  handleOpenChange
}) {
  const responsive = useResponsive();
  return (
    <Popover
      open={open}
      onOpenChange={handleOpenChange}
      trigger="click"
      arrow={false}
      overlayStyle={MyNotificationsPopupContainerStyle.overlayStyle}
      placement={responsive?.isMd ? "bottomRight" : "bottom"}
      disableGutter
      content={
        open && <MyNotificationsPopUpContent handleOpenChange={handleClose} />
      }
    >
      {icon}
    </Popover>
  );
}
